import { render } from "./Logistics.vue?vue&type=template&id=3689e2cc&scoped=true"
import script from "./Logistics.vue?vue&type=script&lang=js"
export * from "./Logistics.vue?vue&type=script&lang=js"

import "./Logistics.vue?vue&type=style&index=0&id=3689e2cc&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3689e2cc"]])

export default __exports__